import React, {useEffect, useState} from "react";
import ProductTable from "./ProductOverviewTable";
import productsApi from "../../../../api/products";
import Loader from "../../../../components/Loader";
import notyf from "../../../../utils/notyfApi";

export default function ProductOverviewTableHandler() {
    //get data from api
    const [products, setProducts] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const response = await productsApi.getAllProducts();
        if (!response.ok) return notyf.error("Error " + response.status)
        setProducts(response.data);
    };

    //laat tabel zien met gegevens via props
    if (products.length > 0) return <ProductTable reload={getData} products={products}/>;
    return <Loader/>
}